import {
	Button,
	Container,
	Paper,
	Step,
	StepLabel,
	Stepper,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import React, { useRef, useState } from "react";
import config from "react-global-configuration";
import { toast } from "react-toastify";
import AceiteConfirmacaoOrcamento from "../../components/Aceite/AceiteConfirmacaoOrcamento";
import AceiteDadosConfirmacaoPedido from "../../components/Aceite/AceiteConfirmacaoPedido";
import AceiteDadosCliente from "../../components/Aceite/AceiteDadosCliente";
import AceiteDadosPagamento from "../../components/Aceite/AceiteDadosPagamento";
import AceiteInserido from "../../components/Aceite/AceiteInserido";
import Cabecalho from "../../components/Pagina/Cabecalho";
import Carregando from "../../components/Pagina/Carregando";
import useFetch from "../../hooks/useFetch";
const AcceptancePage = (props) => {
	const [activeStep, setActiveStep] = useState(0);
	const [loading, setLoading] = useState(false);

	const [clientData, setClientData] = useState({});
	const [pedidoTotvs, setPeidoTotvs] = useState({});
	const [cliente, setCliente] = useState({});

	const confirmationRef = useRef();

	const steps = ["Orçamento", "Cliente", "Pagamento", "Confirmação", "Fim"];

	const urlParams = new URLSearchParams(window.location.search);
	const astecChamadoId = urlParams.get("astec_chamado_id");

	const data = useFetch(
		config.get("url_api") +
			"orcamento/detalhesV2/" +
			urlParams.get("orcamentoId")
	);

	const handleNext = () => {
		if (confirmationRef.current.advanceHandler()) {
			if (!data.response.vendedor) {
				toast.error(
					"O número do seu vendedor no Totvs esta cadastrdado errado."
				);
				return;
			}

			setActiveStep((prevActiveStep) => prevActiveStep + 1);
		}
	};

	const forceNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleReset = () => {
		setActiveStep(0);
	};

	function getStepContent(stepIndex) {
		switch (stepIndex) {
			case 0:
				return (
					<AceiteConfirmacaoOrcamento
						data={data.response}
						ref={confirmationRef}
					/>
				);
			case 1:
				return (
					<AceiteDadosCliente
						data={data.response}
						ref={confirmationRef}
						setLoading={setLoading}
						forceNext={forceNext}
						setCliente={setCliente}
						cliente={cliente}
					/>
				);
			case 2:
				return (
					<AceiteDadosPagamento
						data={data.response}
						ref={confirmationRef}
						setLoading={setLoading}
						forceNext={forceNext}
						cliente={cliente}
						setPeidoTotvs={setPeidoTotvs}
					/>
				);
			case 3:
				return (
					<AceiteDadosConfirmacaoPedido
						cliente={cliente}
						data={data.response}
						ref={confirmationRef}
						pedidoTotvs={pedidoTotvs}
						setLoading={setLoading}
						forceNext={forceNext}
					/>
				);
			case 4:
				return (
					<AceiteInserido
						data={data.response}
						astecChamadoId={astecChamadoId}
					/>
				);

			default:
				return "Unknown stepIndex";
		}
	}

	return (
		<React.Fragment>
			<Cabecalho title={"Aceite do orçamento"} />
			{loading && <Carregando />}
			<Container maxWidth="xl" className="mt-1">
				{!urlParams.get("orcamentoId") && (
					<Paper className="p-1">
						<div className="text-center">O orçamento não foi selecionado.</div>
					</Paper>
				)}
				{!data.response && (
					<Paper>
						<div className="text-center">
							<AutorenewIcon className="spin" />
						</div>
					</Paper>
				)}
				{data.response && data.response.success && (
					<React.Fragment>
						<div className="text-center">
							<Paper className="mb-1">
								<Stepper activeStep={activeStep}>
									{steps.map((step, i) => (
										<Step key={i}>
											<StepLabel>{step}</StepLabel>
										</Step>
									))}
								</Stepper>
							</Paper>
						</div>
						{getStepContent(activeStep)}
						{activeStep !== steps.length - 1 ? (
							<Paper className="mt-1 d-flex j-between p-1">
								<Button
									disabled={activeStep === 0 || loading}
									onClick={handleBack}
								>
									Voltar
								</Button>
								<Button
									variant="contained"
									color="primary"
									onClick={handleNext}
									disabled={loading}
								>
									{loading ? (
										<CircularProgress color="secondary" size="small" />
									) : (
										"Avançar"
									)}
								</Button>
							</Paper>
						) : (
							<div></div>
						)}
					</React.Fragment>
				)}
			</Container>
		</React.Fragment>
	);
};

export default AcceptancePage;
